
export { WrapperEntryName } from "./wrapper.interfaces"